import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.assign.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Drip from 'drip';
import VMask from 'comp/common/VMask';
import throttle from '../../utils/throttle';
import { PROJECT_POPUP_URL } from '@/apis/';
import RealNameModal from 'comp/real-name-modal';
import { SHOW_MODAL_TYPE } from '../../../src/constants/detail';
/** 演出站内公告 【一期采用配置形式】 */
export default {
  name: 'Announcement',
  components: {
    'v-mask': VMask,
    RealNameModal: RealNameModal
  },
  props: {
    projectId: {
      type: Number,
      required: true
    },
    needRealName: Boolean,
    isDegradePopup: {
      type: Boolean,
      default: false
    },
    showPoliceNotice: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: null,
      bodyPosition: '',
      data: null,
      showButton: false,
      buttonDisable: true,
      contentWap: {
        dom: null,
        height: 0,
        scrollHeight: 0
      },
      storeKey: "announcement_".concat(this.projectId),
      realNameKey: "announcement_realname_projectId_".concat(this.projectId),
      policeNoticeKey: "police_notice_projectId_".concat(this.projectId),
      SHOW_MODAL_TYPE: SHOW_MODAL_TYPE
    };
  },
  mounted: function mounted() {
    if (this.isDegradePopup) {
      this.realNamePopFn();
    } else {
      this.getInitData();
    }
  },
  computed: {},
  methods: {
    closeConfirmOverlay: function closeConfirmOverlay() {
      this.show = false;
    },
    getInitData: function getInitData() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var hasKey, _yield$_this$$http$ge, code, data, expire;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Drip.getStore(_this.storeKey);
            case 2:
              hasKey = _context.sent;
              if (!hasKey) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return");
            case 5:
              _context.next = 7;
              return _this.$http.get("".concat(PROJECT_POPUP_URL, "?projectId=").concat(_this.projectId));
            case 7:
              _yield$_this$$http$ge = _context.sent;
              code = _yield$_this$$http$ge.code;
              data = _yield$_this$$http$ge.data;
              if (!(code !== 200 || !data)) {
                _context.next = 14;
                break;
              }
              _context.next = 13;
              return _this.realNamePopFn();
            case 13:
              return _context.abrupt("return");
            case 14:
              _this.bodyPosition = document.body.style.position;
              document.body.style.position = 'fixed';
              expire = +data.expireHour;
              if (expire < 1) {
                expire = Math.ceil(expire * 60) + 'M';
              } else {
                expire = Math.round(expire) + 'H';
              }
              Drip.setStore(_this.storeKey, true, {
                expires: expire
              });
              _this.show = SHOW_MODAL_TYPE.CONFIGE_MODAL;
              _this.data = Object.freeze(data);
              _this.$nextTick(_this.checkButton);
            case 22:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    realNamePopFn: function realNamePopFn() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var expire, hasRealnameKey, hasNoticeKey;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              expire = (_this2.getNextDayTime() - Date.now()) / (1000 * 60 * 60);
              if (expire < 1) {
                expire = Math.ceil(expire * 60) + 'M';
              } else {
                expire = Math.round(expire) + 'H';
              }
              if (!_this2.needRealName) {
                _context2.next = 12;
                break;
              }
              _context2.next = 5;
              return Drip.getStore(_this2.realNameKey);
            case 5:
              hasRealnameKey = _context2.sent;
              if (!hasRealnameKey) {
                _context2.next = 8;
                break;
              }
              return _context2.abrupt("return");
            case 8:
              _this2.show = SHOW_MODAL_TYPE.REALNAME_MODAL;
              Drip.setStore(_this2.realNameKey, true, {
                expires: expire
              });
              _context2.next = 21;
              break;
            case 12:
              _context2.next = 14;
              return Drip.getStore(_this2.policeNoticeKey);
            case 14:
              hasNoticeKey = _context2.sent;
              if (!hasNoticeKey) {
                _context2.next = 17;
                break;
              }
              return _context2.abrupt("return");
            case 17:
              if (_this2.showPoliceNotice) {
                _context2.next = 19;
                break;
              }
              return _context2.abrupt("return");
            case 19:
              _this2.show = SHOW_MODAL_TYPE.POLICE_MODAL;
              Drip.setStore(_this2.policeNoticeKey, true, {
                expires: expire
              });
            case 21:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getNextDayTime: function getNextDayTime() {
      // 获取当前时间戳
      var currentTimestamp = Date.now();

      // 创建当前时间的日期对象
      var currentDate = new Date(currentTimestamp);

      // 设置日期为第二天的凌晨
      currentDate.setDate(currentDate.getDate() + 1);
      currentDate.setHours(0, 0, 0, 0);

      // 获取第二天凌晨的时间戳
      var nextDayTimestamp = currentDate.getTime();
      return nextDayTimestamp;
    },
    /**
     * 初始化按钮
     * @return {Boolean} 初始化结果
     */
    initButton: function initButton() {
      var dom = document.querySelector('.announcement-main');

      // dom不存在 初始化失败
      if (!dom) return false;
      var height = dom.getBoundingClientRect().height;
      var scrollHeight = dom.scrollHeight;
      Object.assign(this.contentWap, {
        dom: dom,
        height: height,
        scrollHeight: scrollHeight
      });

      // 不出现滚动条场景, 什么都不做
      this.showButton = true;
      if (height === scrollHeight) {
        this.buttonDisable = false;
        return;
      }
      this.buttonDisable = true;
      this.checkButton = throttle(this.checkButton);
      dom.addEventListener('scroll', this.checkButton, false);
      return true;
    },
    checkButton: function checkButton() {
      var _this$contentWap;
      if (!((_this$contentWap = this.contentWap) !== null && _this$contentWap !== void 0 && _this$contentWap.dom)) {
        // 初始化失败则不继续执行
        if (!this.initButton()) return;
      }
      var showButton = false;
      var buttonDisable = true;
      var _this$contentWap2 = this.contentWap,
        height = _this$contentWap2.height,
        scrollHeight = _this$contentWap2.scrollHeight,
        dom = _this$contentWap2.dom;
      var scrollTop = dom.scrollTop;
      if (scrollHeight - height - scrollTop <= 5) {
        this.buttonDisable = false;
        dom.removeEventListener('scroll', this.checkButton, true);
      }
    },
    close: function close() {
      if (this.buttonDisable) return;
      this.show = false;
      this.data = null;
      document.body.style.position = this.bodyPosition;
    }
  }
};